import { Pipe, PipeTransform } from '@angular/core';
import { RegExps } from '../resources/regexps.constant';

@Pipe({
  name: 'inputCurrency'
})
export class InputCurrencyPipe implements PipeTransform {
  transform(value: string): string {
    value = value
      ? '$ ' + value.replace(RegExps.THOUSAND_DELIMITER, '$&.')
      : value;
    return value;
  }
}
